<div class="chats-list-toggle-button open" (click)="toggleChat()">
  <nz-badge [nzCount]="unreadCount$ | async" [nzStandalone]="true"></nz-badge>
  <mat-icon *ngIf="!showChatsPanel">chevron_left</mat-icon>
</div>

<nz-drawer
  [nzClosable]="false"
  [nzVisible]="showChatsPanel"
  [nzPlacement]="'right'"
  [nzWidth]="'100vw'"
  (nzOnClose)="toggleChat()"
  [nzBodyStyle]="{
    padding: '0'
  }"
  [nzMask]="true"
  [nzMaskClosable]="true">
  <ng-container *nzDrawerContent>
    <div class="chats-list-wrapper">
      <div class="chats-inner-wrapper">
        <div class="support-chat">
          <app-support-chat-mobile
            (openSupportChatEventEmitter)="toggleChatWindow()"
            (closeSupportChatEventEmitter)="toggleChat()"
            (searchTypeChange)="onSearchTypeChange($event)">
          </app-support-chat-mobile>
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>

<nz-drawer
  [nzClosable]="false"
  [nzVisible]="showChatsPanelWindow"
  [nzPlacement]="'right'"
  [nzWidth]="'100vw'"
  (nzOnClose)="toggleChatWindow()"
  [nzBodyStyle]="{
    padding: '0'
  }"
  [nzMask]="true"
  [nzMaskClosable]="true"
  [nzZIndex]="1001">
  <ng-container *nzDrawerContent>
    <app-support-chat-window-mobile
      *ngIf="openSupportChat$ | async"
      [searchType]="currentSearchType"
      (openSupportChatEventEmitter)="toggleChatWindow($event)">
    </app-support-chat-window-mobile>
  </ng-container>
</nz-drawer>
